import React from 'react';
import { WMButtonProps, WMDialog, WMDialogProps } from '@walkme/wm-ui';
import classes from './StyledWMDialog.module.scss';
import { TRANSITION_DURATION } from '../constants';
import clsx from 'clsx';

interface IStyledWMDialogProps extends Omit<WMDialogProps, 'PaperComponent' | 'buttons'> {
    PaperComponent?: WMDialogProps['PaperComponent'] | string;
    buttons?: (WMButtonProps & { 'data-testid'?: string })[];
}

const StyledWMDialog = (props: IStyledWMDialogProps) => {
    return (
        <WMDialog
            transitionDuration={TRANSITION_DURATION}
            ds2
            {...(props as WMDialogProps)}
            classes={{ ...props?.classes, content: clsx(classes.content, props?.classes?.content) }}
        />
    );
};

export default StyledWMDialog;
